import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingService, WindowRef } from '@spartacus/core';
import { SearchBoxConfig } from '@spartacus/storefront';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { OspCategoriesModel } from '../model/osp-categories.model';
import { OspCategoriesService } from '../services/osp-categories.service';

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  maxProducts: 5,
};

@Component({
    selector: 'app-custom-search-categories',
    templateUrl: './custom-search-categories.component.html',
    styleUrls: ['./custom-search-categories.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomSearchCategoriesComponent implements OnInit, OnDestroy {
  resultPresent: boolean;
  searchPerformed = false;

  @ViewChild('searchDropdown')
  searchDropdown: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElem) {
    const clickedInside =
      this.searchDropdown.nativeElement.contains(targetElem) ||
      this.searchInput.nativeElement.contains(targetElem);
    if (!clickedInside) {
      this.showDropdown = false;
    }
  }
  searchValue: any;

  searchQuery = '';
  searchResults: any[] = [];
  noResultsFound: boolean = false;
  showDropdown: boolean = false;
  itemSelected: boolean;

  contentCategoryCode: string;
  contentItemCode: string;
  public contentItemList$: Observable<OspCategoriesModel>;
  getCodeFromParams$: Observable<any>;
  ospServiceSub: Subscription;
  getCodeSub2: Subscription;
  getCodeSub: Subscription;
  routeSub: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly ospService: OspCategoriesService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: RoutingService,
    protected routerUrl: Router,
    protected windowRef: WindowRef
  ) {
    this.getCodeFromParams$ = combineLatest([
      this.route.params,
      this.route.queryParams,
    ]).pipe(
      map(([params, queryParams]) => {
        return {
          contentCategoryCode:
            params.contentCategoryCode !== undefined
              ? params.contentCategoryCode
              : '',
          contentItemCode: queryParams.item,
        };
      })
    );
  }

  performSearch() {
    this.getCodeSub = this.getCodeFromParams$
      .pipe(
        map((paramsData) => paramsData),
        switchMap((paramsData) => {
          return this.ospService.getContentItems(
            paramsData.contentCategoryCode,
            paramsData.contentItemCode
          );
        })
      )
      .subscribe((res) => {
        if (this.searchQuery.length >= 2) {
          this.searchResults = res?.allSubcategories.flatMap((category) =>
            category.contentItems.filter((item) => {
              return item.title
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase());
            })
          );
        } else {
          this.searchResults = [];
        }
      });
  }

  openAccordion(searchItem: any) {
    searchItem.selected = true;
    this.routerUrl.navigateByUrl(searchItem.url);
    this.searchDropdown.nativeElement.style.display = 'none';
    setTimeout((_) => {
      this.changeDetectorRef.detectChanges();
      window.location.reload();
    }, 100);
  }

  toggleAccordion(item: any) {
    item.selected = !item.selected;
  }

  selectedResult: any;

  clearSearch() {
    this.searchQuery = '';
    this.searchResults = [];
    this.getCodeFromParams$.forEach((category) => {
      category.contentItems.forEach((item) => {
        item.selected = false;
      });
    });
  }

  getDataServiceCategories() {
    return this.getCodeFromParams$;
  }

  search(query: string): void {
    this.searchDropdown.nativeElement.style.display = 'block';
    this.ospServiceSub = this.ospService
      .search(query, DEFAULT_SEARCH_BOX_CONFIG)
      .subscribe((res) => {
        this.searchPerformed = true;
        this.searchResults = res.products;
        this.resultPresent = res.products.length > 0;
        this.changeDetectorRef.detectChanges();
      });
  }

  ngOnInit(): void {
    this.getCodeSub2 = this.getCodeFromParams$
      .pipe(
        map((paramsData) => paramsData),
        switchMap((paramsData) => {
          return this.ospService.getContentItems(
            paramsData.contentCategoryCode,
            paramsData.contentItemCode
          );
        })
      )
      .subscribe((res) => {
        this.contentItemList$ = res?.allSubcategories;
        setTimeout((_) => {
          this.changeDetectorRef.detectChanges();
        }, 100);
      });

    this.routeSub = this.route.queryParams.subscribe((params) => {
      if (params.query) {
        this.searchQuery = params.query;
      }
    });
  }
  ngOnDestroy(): void {
    this.getCodeSub2?.unsubscribe();
    this.ospServiceSub?.unsubscribe();
    this.getCodeSub2?.unsubscribe();
    this.getCodeSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }
  openResultPage(query): void {
    this.router.goByUrl('help-center/search?query=' + query);
  }

  hideDropdown() {
    if (this.searchQuery.length < 3) {
      this.showDropdown = false;
    }
  }
}
